import {persist} from "zustand/middleware";
import {createStore} from "zustand/vanilla";

const stores = [];
const zustand = {
  persist,
  createStore,
  stores,
};

window.zustand = zustand;
